import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import { getImageUrl } from './utils/utils';
import {
  updateSeoTags,
  upsertJsonLd,
  removeJsonLd,
  buildLocalBusinessSchema,
  buildBreadcrumbSchema,
  clearPageSpecificSchema,
} from './utils/seo';
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/utility.css';
import './assets/css/responsive.css';
import VueLazyload from 'vue3-lazyload';

axios.defaults.baseURL = 'https://admin.dubaipetsgroomer.com/api';
// axios.defaults.baseURL = 'http://dpg-backend.test/api';

const websiteName = 'Dubai Pets Groomer';
const app = createApp(App);

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$getImageUrl = getImageUrl;
app.config.globalProperties.$websiteName = websiteName;

app.use(ToastPlugin);
app.use(VueLazyload, {
  loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAusB9QpqlPYAAAAASUVORK5CYII=',
  error: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAusB9QpqlPYAAAAASUVORK5CYII='
});

function applyRouteSeo(to) {
  updateSeoTags(to);
  clearPageSpecificSchema();

  upsertJsonLd('ld-local-business', buildLocalBusinessSchema());

  const crumbs = [{ name: 'Home', path: '/' }];
  if (to.path !== '/') {
    crumbs.push({
      name: to.meta?.title || to.name || 'Page',
      path: to.path,
    });
  }
  upsertJsonLd('ld-breadcrumb', buildBreadcrumbSchema(crumbs));

  if (to.meta?.noindex) {
    removeJsonLd('ld-local-business');
  }
}

router.afterEach((to) => {
  applyRouteSeo(to);
});

app.use(router).mount('#app');
